import React, { useEffect, useState } from 'react';
import { doc } from 'firebase/firestore';
import { safeOnSnapshot } from '../../utils/firestoreSubscriptions';
import { useSearchParams } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';
import { db } from '../../firebase-client';
import { PairingGuidance } from '../../components/teams/detailCards/mentoring';

export default function MentoringPairingView() {
  const { user } = useAuth();
  const [searchParams] = useSearchParams();
  const [pairing, setPairing] = useState(null);
  const [error, setError] = useState('');
  const teamId = searchParams.get('teamId') || '';
  const pairingId = searchParams.get('pairingId') || '';

  useEffect(() => {
    if (!teamId || !pairingId) return undefined;
    return safeOnSnapshot(
      doc(db, 'teams', teamId, 'mentoringPairings', pairingId),
      (snap) => setPairing(snap.exists() ? { id: snap.id, ...snap.data() } : null),
      (err) => setError(err?.message || 'This mentoring pairing is not available.')
    );
  }, [pairingId, teamId]);

  const canSubmit = pairing?.participantIds?.includes(user?.uid);

  return (
    <main className="search-page">
      <div className="card">
        <div className="card-body">
          <h1>Mentoring pairing</h1>
          {error && <p className="text-danger" role="alert">{error}</p>}
          {!pairing && !error && <p className="text-muted">Loading mentoring details…</p>}
          {pairing && (
            <>
              <p><strong>{pairing.mentorName || 'Mentor'}</strong> mentoring <strong>{pairing.menteeName || 'Mentee'}</strong></p>
              <a className="btn btn--primary btn--sm" href={`/messages/${pairing.threadId}`}>Open conversation</a>
              <PairingGuidance teamId={teamId} pairing={pairing} currentUserId={user?.uid || ''} canSubmit={canSubmit} />
            </>
          )}
        </div>
      </div>
    </main>
  );
}
